import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';

import { AppConfig } from '../config/app.config';
import { IReturnObject } from '../shared/return-object.model';

@Injectable()
export class SupplierService {
    constructor(private config: AppConfig, private http: Http) { }

    private apiUrl: string = this.config.get('apiUrl') + 'Supplier';

    searchSupplier(searchString: string): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/SearchSupplier/?searchString=${searchString}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getSupplierBySupplierNo(supplierNo: string, extendedSupplierNo: string): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetSupplierBySupplierNo/?supplierNo=${supplierNo}&extendedSupplierNo=${extendedSupplierNo}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getSupplier(supplierId: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetSupplier/?supplierId=${supplierId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    existsContactsForSendForApproval(supplierNos: string): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/ExistsContactsForSendForApproval/?supplierNos=${supplierNos}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    isSupplierInfoValid(date: string): boolean {
        let currentDate = new Date(date);
        let newMonth = currentDate.getMonth() + this.config.get("SupplierContactUpdateTime");
        if (newMonth / 11 > 1)
            currentDate.setFullYear(currentDate.getFullYear() + 1, newMonth % 12);
        else
            currentDate.setMonth(newMonth);

        return currentDate < new Date()
            ? true
            : false;
    }



}



// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/supplier/supplier.service.ts